import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgExpressTruck = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M20.73 4.895a.875.875 0 0 1 .785.87v3.243h2.035l.215.007c1.062.069 1.94.647 2.54 1.456.632.854.974 1.985.974 3.177v6.94a.876.876 0 0 1-.875.876h-1.806a4 4 0 0 1-7.946-.001h-4.304a4 4 0 0 1-7.946 0H4.17a.875.875 0 0 1 0-1.75h.419a4 4 0 0 1 7.574 0h4.676a4.006 4.006 0 0 1 2.927-2.62V6.64H3.345a.875.875 0 1 1 0-1.75H20.64l.09.005ZM8.375 18.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm12.25 0a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm.89-1.65a4.006 4.006 0 0 1 2.897 2.614h1.117v-6.066c0-.873-.252-1.625-.63-2.136-.326-.44-.728-.688-1.162-.742l-.187-.012h-2.035V17.1Z"
      clipRule="evenodd"
    />
    <path d="M8.376 13.13a.875.875 0 0 1 0 1.74l-.089.005H3.346a.875.875 0 0 1 0-1.75h4.941l.089.005ZM6.905 9.013a.875.875 0 0 1 0 1.74l-.089.005H1.875a.875.875 0 0 1 0-1.75h4.941l.09.005Z" />
  </svg>
);
export default SvgExpressTruck;
